module.exports = __webpack_public_path__ + "BingSiteAuth.xml";


//////////////////
// WEBPACK FOOTER
// ./BingSiteAuth.xml
// module id = 744
// module chunks = 9